export default "__VITE_ASSET__BqKIkXTl__"